import { useMutation } from "@apollo/client";

import { ProtocolCourseCreateInput } from "~/__generated__";
import { COURSE_GET_ALL } from "~/modules/settings/course/routes/CourseListRoute/api/useCourseListRoute_GetAll";

import { ProtocolEditRoute_CourseCreateDocument } from "../mutations.generated";
import { PROTOCOL_GET_BY_ID } from "./useProtocolEditRoute_GetById";

export default function useProtocolCourseCreate() {
    const [createProtocolCourseMutation, { loading, error, data }] = useMutation(ProtocolEditRoute_CourseCreateDocument, {
        refetchQueries: [PROTOCOL_GET_BY_ID, COURSE_GET_ALL],
    });

    const createProtocolCourse = async (input: ProtocolCourseCreateInput) => {
        const response = await createProtocolCourseMutation({
            variables: { input },
        });

        return response.data?.protocolCourseCreate;
    };

    return {
        loading,
        error,
        data: data?.protocolCourseCreate,
        createProtocolCourse,
    };
}
